import { useQuery } from '@apollo/react-hooks';
import { DateTime, ImageUpload } from 'modules';
import { FileByNameQuery } from 'queries/File/File';
import React, { useContext, useEffect } from 'react';
import { WebsocketActions, WebsocketContext } from 'services/WebsocketContext';
import './style.scss';

interface UploadIdentityCardButtonProps {
  label: string;
  contract: GQL.IContract;
  isClient2?: boolean;
  imageType: 'front' | 'back';
  isInvalid: string[];
  updateIsInvalid: (file: string, value: boolean) => void;
}

const UploadIdentityCardButton = ({
  label,
  contract,
  isClient2 = false,
  imageType,
  isInvalid,
  updateIsInvalid,
}: UploadIdentityCardButtonProps) => {
  const wsContext = useContext(WebsocketContext);

  const fileDescription = `IDENTITY_CARD${isClient2 ? '_2_' : '_'}${imageType.toUpperCase()}`;

  const fileByNameQuery = useQuery(FileByNameQuery, {
    variables: {
      where: {
        id_files: contract.id_files || 0,
        fileDescriptionLike: fileDescription,
      },
    },
    fetchPolicy: 'network-only',
  });

  const { data } = fileByNameQuery;

  const onChange = (): void => {
    // aktualizace souboru s podpisem
    fileByNameQuery.refetch();
    // aktualizace stavu smlouvy
    wsContext.send({
      action: WebsocketActions.REFRESH_CONTRACT_STATE,
    });
    // aktualizace nahraného souboru
    wsContext.send({
      action: WebsocketActions.REFRESH_CONTRACT_IDENTITY_CARD_FILE,
      value: { name: fileDescription },
    });
  };

  useEffect(() => {
    if (isInvalid.includes(fileDescription)) {
      updateIsInvalid(fileDescription, false);
      fileByNameQuery.refetch();
    }
    // eslint-disable-next-line
  }, [isInvalid]);

  return (
    <div className="identity-card-upload">
      {label}
      <br />
      {data?.fileByName && (
        <a
          href={data?.fileByName?.file_url}
          className="btn btn-sm btn-outline-secondary btn-light"
          target="_blank"
          rel="noopener noreferrer"
        >
          Obrázok nahraný <DateTime value={data?.fileByName?.created} />
        </a>
      )}
      <ImageUpload
        name="identityCard"
        buttonLabel={data?.fileByName ? `Nahrať znova` : 'Nahrať'}
        multiple={false}
        uploadData={{
          contractId: contract.id,
          isClient2,
          imageType,
        }}
        uploadURL={`${process.env.REACT_APP_API_URL}/contract/upload/identity-card`}
        onChange={onChange}
      />
    </div>
  );
};

export default UploadIdentityCardButton;
